var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/user/login/form-fields.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "core/templates/modal/user/login/form-fields.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_4 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
if(t_1.hasOwnProperty("hasErrors")) {
var t_6 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_6);
if(t_1.hasOwnProperty("validatedField")) {
var t_7 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_7);
output += "\n";
env.getTemplate("macros/urls.j2", false, "core/templates/modal/user/login/form-fields.j2", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(t_8.hasOwnProperty("signUpUrl")) {
var t_11 = t_8.signUpUrl;
} else {
cb(new Error("cannot import 'signUpUrl'")); return;
}
context.setVariable("signUpUrl", t_11);
if(t_8.hasOwnProperty("loginUrl")) {
var t_12 = t_8.loginUrl;
} else {
cb(new Error("cannot import 'loginUrl'")); return;
}
context.setVariable("loginUrl", t_12);
if(t_8.hasOwnProperty("forgotPasswordUrl")) {
var t_13 = t_8.forgotPasswordUrl;
} else {
cb(new Error("cannot import 'forgotPasswordUrl'")); return;
}
context.setVariable("forgotPasswordUrl", t_13);
output += "\n\n\n<div class=\"c-form__field c-form__field--required ";
output += runtime.suppressValue((lineno = 4, colno = 60, runtime.callWrap(t_6, "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"login")),"messages")),"email")])), env.opts.autoescape);
output += "\">\n\n    <label for=\"email\" class=\"c-modal-form__label\">\n        ";
output += runtime.suppressValue((lineno = 7, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_email",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n    </label>\n\n    <input id=\"email\" type=\"email\" name=\"email\" class=\"c-form__text c-modal-form__email\"\n        autofocus\n        data-qa-login-email\n        ";
if(!runtime.contextOrFrameLookup(context, frame, "renderedOutsideOfModal")) {
output += "data-parsley-type=\"email\"\n        ";
output += runtime.suppressValue((lineno = 15, colno = 23, runtime.callWrap(t_7, "validatedField", context, ["ERROR_LOGIN_INVALID_USERNAME",runtime.makeKeywordArgs({"field": runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"login")),"messages")),"email")})])), env.opts.autoescape);
;
}
output += "\n        value=\"";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"login")),"email")), env.opts.autoescape);
output += "\"\n        aria-required=\"true\"\n        aria-describedby=\"email_error\" />\n\n    ";
output += runtime.suppressValue((lineno = 21, colno = 23, runtime.callWrap(t_5, "displayFieldErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"login")),"messages")),"email"),runtime.makeKeywordArgs({"id": "email"})])), env.opts.autoescape);
output += "\n\n</div>\n\n<div class=\"c-form__field c-form__field--required c-modal-login__password-field ";
output += runtime.suppressValue((lineno = 25, colno = 90, runtime.callWrap(t_6, "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"login")),"messages")),"password")])), env.opts.autoescape);
output += "\">\n\n    <label for=\"password\" class=\"c-modal-form__label\">\n        ";
output += runtime.suppressValue((lineno = 28, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_password",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n    </label>\n\n    <input\n        id=\"password\"\n        ";
if(!runtime.contextOrFrameLookup(context, frame, "renderedOutsideOfModal")) {
output += runtime.suppressValue((lineno = 34, colno = 23, runtime.callWrap(t_7, "validatedField", context, ["INVALID_PASSWORD",runtime.makeKeywordArgs({"field": runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"login")),"messages")),"password")})])), env.opts.autoescape);
;
}
output += "\n        type=\"password\"\n        name=\"password\"\n        class=\"c-form__text c-modal-form__password\"\n        data-qa-login-password\n        aria-required=\"true\"\n        aria-describedby=\"password_error\" />\n\n    ";
output += runtime.suppressValue((lineno = 43, colno = 23, runtime.callWrap(t_5, "displayFieldErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"login")),"messages")),"password"),runtime.makeKeywordArgs({"id": "password"})])), env.opts.autoescape);
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/user/login/form-fields.j2"] , dependencies)